import {Helmet} from '@dr.pogodin/react-helmet';
import {isFeatureEnabled} from 'feature-flags';
import {Action, openDialog} from 'platform/components';

import {useMatch} from 'react-router-dom';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {importRoutes} from '@dms/routes';
import {
  DocumentExtractionImportDialog,
  Main,
  PageTab,
  useIsLicenceEnabled,
  usePermissions,
} from '@dms/shared';

import {buildArray} from 'shared/web';

import {ExtractedDeliveryNotes} from './components/ExtractedDeliveryNotes';
import {ImportDialog} from './components/ImportDialog';
import {Imports} from './components/Imports';

export function ImportsOverview() {
  const importsMatch = useMatch(importRoutes.overview);
  const extractedDeliveryNotesMatch = useMatch(importRoutes.extractedDeliveryNotes);

  const {isWarehouseModuleEnabled} = useIsLicenceEnabled();
  const [canExtractDeliveryNote] = usePermissions({
    permissionKeys: ['deliveryNoteAiExtract'],
  });

  const isExtractedDeliveryNotesEnabled =
    isWarehouseModuleEnabled &&
    isFeatureEnabled(featureFlags.AFS_WAREHOUSE_EXTRACT_DELIVERY_NOTE) &&
    canExtractDeliveryNote;

  const openImportDialog = () => {
    openDialog(<ImportDialog dialogId="import-dialog" />, {
      title: i18n.t('entity.import.actions.createImportTask'),
      id: 'import-dialog',
    });
  };

  const openImportDialogForDeliveryNote = () => {
    openDialog(
      <DocumentExtractionImportDialog
        dialogId="document-extraction"
        data-testid="document-extraction"
      />,
      {
        id: 'document-extraction',
      }
    );
  };

  const tabs = buildArray<PageTab>()
    .add({
      id: 'imports',
      title: i18n.t('entity.import.heading.title'),
      content: <Imports />,
      href: importRoutes.overview,
    })
    .when(isExtractedDeliveryNotesEnabled, {
      id: 'extracted-delivery-notes',
      title: i18n.t('page.import.labels.extractedDeliveryNotes'),
      content: <ExtractedDeliveryNotes />,
      href: importRoutes.extractedDeliveryNotes,
    });

  const actions = buildArray<Action>()
    .when(importsMatch, {
      type: 'button',
      title: i18n.t('entity.import.actions.createImportTask'),
      onClick: openImportDialog,
    })
    .when(extractedDeliveryNotesMatch && isExtractedDeliveryNotesEnabled, {
      type: 'button',
      title: i18n.t('entity.import.actions.extractDeliveryNote'),
      onClick: openImportDialogForDeliveryNote,
    });

  return (
    <>
      <Helmet title={i18n.t('module.import.title')} />
      <Main isFullHeight tabs={tabs} actions={actions} />
    </>
  );
}
